import { map } from 'lodash';
import { Location, ILocationData } from './location';
import { Permission, IPermissionData } from './permission';

export interface IUserRoleData {
    roleId?: number;
    roleDescription?: string;
    isActive?: boolean;
    roleName?: string;
    locations?: ILocationData[];
    userPermissions?: IPermissionData[];
}

export class UserRole {
    roleId: number;
    roleDescription: string;
    isActive: boolean;
    roleName: string;
    userPermissions: Permission[];
    locations: Location[];

    constructor(data: Partial<IUserRoleData>) {
        this.roleId = data?.roleId;
        this.roleDescription = data?.roleDescription;
        this.isActive = data?.isActive;
        this.roleName = data?.roleName;
        this.locations = data?.locations ? map(data.locations, (l: ILocationData) => new Location(l)) : undefined;
        this.userPermissions = data?.userPermissions ? map(data.userPermissions, (l: IPermissionData) => new Permission(l)) : undefined;
    }

}